import { useMemo, useRef } from 'react';
import { GridToolbarProps } from '@mui/x-data-grid-pro';

export function useToolbar<T extends object>(
  ToolbarComponent: React.ComponentType<T>,
  extraProps: T
) {
  const extraPropsRef = useRef(extraProps);
  extraPropsRef.current = extraProps;
  return useMemo(() => {
    return function ToolbarWrapper(gridProps: GridToolbarProps) {
      return <ToolbarComponent {...gridProps} {...extraPropsRef.current} />;
    };
  }, [ToolbarComponent]);
}
